<template>
  <bvue-ui-view class="flex flex-col w-full" :scroll="true">
    <h1 class="flex-1">Reserva</h1>
    <div class="form-group flex-1">
      <label>Nombre</label>
      <input type="text" class="form-input" v-model="item.name">
    </div>
    <div class="form-group flex-1">
      <label>Nombre_us</label>
      <input type="text" class="form-input" v-model="item.name_us">
    </div>
    <div class="form-group flex-1">
      <label>Nombre_de</label>
      <input type="text" class="form-input" v-model="item.name_de">
    </div>
    <div class="form-group flex-1">
      <label>Cooperante</label>
      <input type="text" class="form-input" v-model="item.partner">
    </div>
    <div class="form-group flex-1">
      <label>Cooperante_us</label>
      <input type="text" class="form-input" v-model="item.partner_us">
    </div>
    <div class="form-group flex-1">
      <label>Cooperante_de</label>
      <input type="text" class="form-input" v-model="item.partner_de">
    </div>
    <div class="form-group flex-1">
      <label>Descripción</label>
      <textarea name="description" class="form-input" v-model="item.description"></textarea>
    </div>
    <div class="form-group flex-1">
      <label>Descripción_us</label>
      <textarea name="description_us" class="form-input" v-model="item.description_us"></textarea>
    </div>
    <div class="form-group flex-1">
      <label>Descripción_de</label>
      <textarea name="description_de" class="form-input" v-model="item.description_de"></textarea>
    </div>
    <div class="form-group flex-1">
      <label>Ecosistema</label>
      <select name="ecosystem" class="form-select" v-model="item.ecosystem">
        <option v-for="ecosystem in ecosystems" :value="ecosystem.id" :key="ecosystem.id">
          {{ ecosystem.name }}
        </option>
      </select>
    </div>
    <div class="form-group flex-1">
      <label>Precio</label>
      <input type="text" class="form-input" v-model="item.price">
      El precio base para Ecuador. El precio final se calcula en base a la tabla de conversiones.
    </div>
    <div>
      <label>Url del Video de Presentación (Importante: Tiene que contener Embed en el URL)</label>
      <input type="url" class="form-input" v-model="item.url" />
    </div>
    <div class=" flex my-4 justify-end">
      <div>
        <button @click="store" :class="['btn', 'btn-primary', loading]">{{isNew ? 'Crear' : 'Guardar'}}</button>
      </div>
    </div>
  </bvue-ui-view>
</template>

<script>
import firebase from '@/firebase'
import { mapState } from 'vuex'
export default {
  name: 'NewReserve',
  components: {  },
  props: {
    modalData: Object
  },
  data() {
    return {
      isNew: true,
      loading: [],
      item: {
        region: {
          fillColor: '#aac92d',
          fillOpacity: 0.1,
          strokeColor: '#aac92d',
          strokeOpacity: 0.8,
          strokeWeight: 8,
          path: [
            {lat: -0.07141111432402267, lng: -77.838134765625},
            {lat: -0.10098107191524712, lng: -76.0432413267867},
            {lat: -1.929839759051124, lng: -76.9221475767867},
          ]
        }
      }
    }
  },
  computed: {
    ...mapState('ecosystems', {ecosystems: 'items'})
  },
  methods: {
    async store() {
      this.loading = ['loading', 'disabled']
      const collection = firebase.firestore.collection('reserves')
      if (this.isNew) {
        await collection.doc(this.item.id).set(this.item)
      } else {
        var item = {
          name: this.item.name,
          name_us:  this.item.name_us,
          name_de: this.item.name_de,
          partner: this.item.partner,
          video: this.item.video,
          partner_us: this.item.partner_us,
          partner_de: this.item.partner_de,
          description: this.item.description,
          description_us: this.item.description_us,
          description_de: this.item.description_de,
          ecosystem: this.item.ecosystem,
          price: this.item.price,
          url: this.item.url
        }
        await collection.doc(this.item.id).update(item)
      }
      this.loading = []
      this.$bvueUi.modal.close()
      if (this.isNew){
        this.$router.push('/admin/reserves/'+this.item.id)
      }
    }
  },
  created() {
    if (this.modalData && this.modalData.id) {
      this.isNew = false
      this.item = this.modalData
    } else {
      this.item.id = firebase.firestore.collection('reserves').doc().id
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/admin/NewReserve.vue